import { render, staticRenderFns } from "./postDetail.vue?vue&type=template&id=24ba5f70&scoped=true&lang=html&"
import script from "./postDetail.vue?vue&type=script&lang=js&"
export * from "./postDetail.vue?vue&type=script&lang=js&"
import style0 from "./postDetail.vue?vue&type=style&index=0&id=24ba5f70&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ba5f70",
  null
  
)

export default component.exports